/** Request header the client sends when reloading a named `<Frame>`. */
export const REMIX_FRAME_TARGET_HEADER = 'x-remix-target'
